module.exports = __webpack_public_path__ + "static/img/13.376620f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/13.png
// module id = HVAB
// module chunks = 0